import { IStaffRole } from 'features/cost-analysis/team/expertises/types';
import { BaseService } from 'shared/services/BaseService';

class StaffRoleService extends BaseService<IStaffRole> {
  constructor() {
    super('staff-management/staff-roles');
  }
  canDelete = true;
}

export const staffRoleService = new StaffRoleService();
